











































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GlobalMixins from '@/mixins';
import { IStatement } from '../interfaces';

const onClickaway = require('vue-clickaway');

@Component({
	directives: {
		onClickaway: onClickaway.directive
	}
})
export default class AppNav extends GlobalMixins {
	shareModalOpen: boolean = false
	shareSuccess: boolean = false
	shareFail: boolean = false
	
	get indicatorWidth(): number {
		if (this.hideNav) return 0
		if (this.$route.name === 'statement') {
			return ((100 / (this.statements.length + 3)) * JSON.parse(this.$route.params.id))
		} else if (this.$route.name === 'shootout-statement') {
			return ((100 / this.shootoutStatements.length) * JSON.parse(this.$route.params.id))
		} else if (this.$route.name === 'select-statements') {
			return ((100 / (this.statements.length + 3)) * (this.statements.length + (this.$store.getters.showAnalyticsQuestion ? 1 : 1.5)))
		} else if (this.$route.name === 'select-parties') {
			return this.$store.getters.showAnalyticsQuestion ? ((100 / (this.statements.length + 3)) * (this.statements.length + 2)) : 100 
		} else if (this.$route.name === 'select-analytics' || this.$route.name === 'results' || this.$route.name === 'choices-overview') {
			return 100
		}

		return 0
	}
	get disableNavButtons(): boolean {
		if (this.hideNav) return true
		if (this.$route.name === 'statement' && this.$route.params.id === '1' && this.config.settings.skipStart) return true

		return false
	}
	get embedCode(): string {
		if (this.$route.name === 'statement') {
			return `<iframe title="${this.dictionary.app.title}" width="1080" height="810" src="${window.location.protocol}//${window.location.host}?${this.slugify(this.dictionary.statement.tabTitle)}=${(this.$route.params.id)}"></iframe>`
		} else {
			return `<iframe title="${this.dictionary.app.title}" width="1080" height="810" src="${window.location.protocol}//${window.location.host}"></iframe>`
		}
	}
	get hideNav(): boolean {
		if (this.$route.name === 'start') return true
		if (this.$route.name === 'pageNotFound') return true

		return false
	}
	get showShareButtons(): boolean {
		if (this.$route.name === 'statement') {
			if (!this.dictionary.statement.share) return false
			
			return (this.dictionary.statement.share.facebookWithStatement || this.dictionary.statement.share.twitterWithStatement || this.dictionary.statement.share.linkedinWithStatement || this.dictionary.statement.share.whatsappWithStatement) ? true : false
		} else {
			if (!this.dictionary.app.share) return false

			return (this.dictionary.app.share.facebook || this.dictionary.app.share.twitter || this.dictionary.app.share.linkedin || this.dictionary.app.share.whatsapp) ? true : false
		}
	}
	get shareTitle(): string {
		if (this.$route.name === 'statement' && this.dictionary.statement.share && this.dictionary.statement.share.title) {
			return this.dictionary.statement.share.title
		} else if(this.dictionary.app.share.title) {
			return this.dictionary.app.share.title
		} else {
			return ''
		}
	}
	get shareSubtitle(): string {
		if (this.$route.name === 'statement' && this.dictionary.statement.share && this.dictionary.statement.share.subtitle) {
			return this.dictionary.statement.share.subtitle
		} else if(this.dictionary.app.share.subtitle) {
			return this.dictionary.app.share.subtitle
		} else {
			return ''
		}
	}

	@Watch('shareModalOpen')
	onShareModalOpenChange() {
		if (!this.shareModalOpen) {
			this.shareSuccess = false
			this.shareFail = false
		}
	}
	@Watch('$route')
	onRouteChange() {
		this.shareModalOpen = false
	}
	
	back() {
		this.shareModalOpen = false

		if (this.$route.name === 'statement' || this.$route.name === 'shootout-statement') {
			if (this.$route.params.id === '1') {
				if (this.$route.name === 'shootout-statement') {
					this.$router.push({
						name: 'results'
					})
				} else {
					if (!this.config.settings.skipStart) {
						this.$router.push({
							name: 'start'
						})
					}
				}
			} else {
				this.$router.push({
					name: (this.$route.name === 'shootout-statement' ? 'shootout-statement' : 'statement'),
					params: {
						id: JSON.stringify((JSON.parse(this.$route.params.id) - 1)),
						title: this.slugify(this.statementTitleToString(this.$store.getters.statement((JSON.parse(this.$route.params.id) - 1)).title))
					}
				})
			}
		} else if (this.$route.name === 'select-statements') {
			this.toLastStatement()
		} else if (this.$route.name === 'select-parties') {
			if (this.config.settings.maxSelectedStatements) {
				this.$router.push({ name: 'select-statements' })
			} else {
				this.toLastStatement()
			}
		} else if (this.$route.name === 'select-analytics') {
			this.$router.push({ name: 'select-parties' })
		} else if (this.$route.name === 'results') {
			this.$router.push({ name: this.$store.getters.showAnalyticsQuestion ? 'select-analytics' : 'select-parties' })
		} else if (this.$route.name === 'choices-overview') {
			this.$router.push({ name: 'results' })
		}
	}
	next() {
		this.shareModalOpen = false
	}
	copyEmbedCode() {
		this.$copyText(this.embedCode)
			.then(e => {
				this.shareModalOpen = true
				this.shareSuccess = true
			})
			.catch(e => {
				this.shareModalOpen = true
				this.shareFail = true
			})
	}
	toLastStatement(): void {
		const statements = this.statements

		this.$router.push({
			name: 'statement',
			params: {
				id: JSON.stringify(statements.length),
				title: this.slugify(this.statementTitleToString((this.$store.getters.statement(statements.length) as IStatement).title))
			}
		})
	}

	created() {
		document.addEventListener('keyup', e => {
			if (e.code === 'Escape') {
				this.shareModalOpen = false
			}
		})
	}
}
